/*
Product Hero
*/

class ProductHero extends HTMLElement {
  connectedCallback() {
    this.productTags = JSON.parse(this.dataset["productTags"]);
    this.selectedVariantId = JSON.parse(this.dataset["selectedVariantId"]);
    this.variants = JSON.parse(this.dataset["variants"]);
    this.productOptions = JSON.parse(this.dataset["productOptions"]);

    if (this.variants) {
      this.selectedVariant = this.variants.find(
        (variant) => variant.id === this.selectedVariantId
      );
    }

    this.notifyMeSection = document.querySelector("notify-me");

    this.initProductForm();
    this.updateUI();
    window.addEventListener("popstate", this.handlePopNavigation.bind(this));
  }

  handlePopNavigation() {
    const params = ProductHero.paramsToObject();
    const newVariantId = +params.variant;
    this.selectedVariant =
      this.variants.find((variant) => variant.id === newVariantId) ||
      this.variants[0];
    this.updateUI();
  }

  initProductForm() {
    const atcButton = this.querySelector(".add-to-cart-js");
    atcButton.addEventListener("click", () => {
      const siteCart = document.querySelector("site-cart");
      siteCart.addVariantToCart(this.selectedVariant.id, 1);

      atcButton.innerHTML = "Added to Cart!"

      setTimeout(() => {
        atcButton.innerHTML = "Add to Cart"
      }, 1500)
    });

    const optionGroups = Array.from(this.querySelectorAll(".option-group-js"));
    for (const optGroup of optionGroups) {
      const radioEls = Array.from(optGroup.querySelectorAll("input"));
      for (const radioEl of radioEls) {
        radioEl.addEventListener("change", () => {
          const value = radioEl.value;
          const optGroupName = optGroup.dataset.optName;
          const checked = radioEl.checked;

          if (checked) {
            const optPrediction = this.predictOption(optGroupName, value);
            this.selectedVariant = optPrediction.variant;
          }
          ProductHero.insertUrlParam("variant", this.selectedVariant.id);
          this.updateUI(optGroupName === "Color");
        });
      }
    }
  }

  updateUI(renderAll = true) {
    const atcButton = this.querySelector(".add-to-cart-js");

    this.updateOptions();
    this.updatePrices();

    if (renderAll) {
      this.updateGallery();
    }

    if (!this.selectedVariant.available) {
      atcButton.innerHTML = "Sold Out";
      atcButton.setAttribute("disabled", "");
      atcButton.style.opacity = "30%";
      this.notifyMeSection.classList.remove("hidden");
    } else {
      atcButton.innerHTML = "Add to Cart";
      atcButton.removeAttribute("disabled");
      this.notifyMeSection.classList.add("hidden");
      atcButton.style.opacity = "100%";
    }
  }

  updateOptions() {
    const optionGroups = Array.from(this.querySelectorAll(".option-group-js"));

    for (const optGroup of optionGroups) {
      const radioEls = Array.from(optGroup.querySelectorAll("input"));
      for (const radioEl of radioEls) {
        const value = radioEl.value;
        const optGroupName = optGroup.dataset.optName;

        const optPrediction = this.predictOption(optGroupName, value);
        if (optPrediction.available) {
          radioEl.classList.remove("sold-out");
        } else {
          radioEl.classList.add("sold-out");
        }

        if (this.selectedVariant.options.includes(value)) {
          radioEl.checked = true;
        } else {
          radioEl.checked = false;
        }
      }
    }
  }

  updatePrices() {
    const variantPrice = this.selectedVariant.price / 100;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: Shopify.currency.active,
    });
    const variantPriceStr = formatter.format(variantPrice).replace(/\.00$/, "");
    const priceTargets = Array.from(this.querySelectorAll(".price-target-js"));
    for (const priceTargetEl of priceTargets) {
      priceTargetEl.innerHTML = `${variantPriceStr} ${Shopify.currency.active}`;
    }
  }

  updateGallery() {
    this.selectedVariant.options.forEach((option) => {
      const allGalleries = this.querySelectorAll("[data-gallery]");
      const galleries = Array.from(
        this.querySelectorAll(`[data-gallery="${option}"]`)
      );
      if (galleries.length > 0) {
        allGalleries.forEach((gal) => gal.classList.add("hidden"));
        galleries.forEach((gallery) => gallery.classList.remove("hidden"));
      }
    });
  }

  predictOption(optionName, value) {
    const predictedOptions = this.productOptions.map((option) => {
      if (option.name === optionName) {
        return value;
      }
      return this.selectedVariant.options.find((opt) =>
        option.values.includes(opt)
      );
    });

    const predictedVariant = ProductHero.findVariantByOptions(
      this.variants,
      predictedOptions
    );

    return {
      available: predictedVariant.available,
      priceDiff: predictedVariant.price - this.selectedVariant.price,
      variant: predictedVariant,
    };
  }

  static predictVariantOption(
    variants,
    optionsWithValues,
    selectedVariant,
    optionName,
    value
  ) {
    const predictedOptions = optionsWithValues.map((option) => {
      if (option.name === optionName) {
        return value;
      }

      return selectedVariant.options.find((opt) => option.values.includes(opt));
    });

    const predictedVariant = ProductHero.findVariantByOptions(
      variants,
      predictedOptions
    );

    return {
      available: predictedVariant.available,
      priceDiff: predictedVariant.price - selectedVariant.price,
      variant: predictedVariant,
    };
  }

  static findVariantByOptions(variants, options) {
    const variant = variants.find((variant) => {
      const currentOptsStr = JSON.stringify(options.sort());
      const variantOptsStr = JSON.stringify(variant.options.sort());
      return currentOptsStr === variantOptsStr;
    });

    return variant;
  }

  static insertUrlParam(key, value) {
    if (history.pushState) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, value);
      let newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        searchParams.toString();
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  static paramsToObject() {
    const urlParams = new URLSearchParams(window.location.search);
    const entries = urlParams.entries();
    const result = {};
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }
}

customElements.define("product-hero", ProductHero);

/*
Guide Toggle
*/

class GuideToggle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("Guide toggle component should have a button as a child!");
    }

    this.addEventListener("click", (e) => {
      const guide = document.querySelector("site-guide");
      if (guide) {
        guide.toggleGuide();
      }
    });
  }
}

customElements.define("guide-toggle", GuideToggle);

/*
Site Guide
*/

class SiteGuide extends HTMLElement {
  constructor() {
    super();
    this.guide = null;
  }

  connectedCallback() {
    this.guide = document.querySelector(".site-guide");
  }

  openGuide() {
    if (this.guide) {
      this.guide.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  }

  closeGuide() {
    if (this.guide) {
      this.guide.classList.remove("active");
      document.body.removeAttribute("style");
    }
  }

  toggleGuide() {
    if (this.guide.classList.contains("active")) {
      this.closeGuide();
    } else {
      this.openGuide();
    }
  }
}

customElements.define("site-guide", SiteGuide);

/*
Unit Converter
*/

class UnitConverter extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const buttons = this.querySelectorAll("[data-unit]");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        if (!button.classList.contains("active")) {
          buttons.forEach((btn) => {
            btn.classList.replace("button--black", "button--ghosted-black");
            btn.classList.remove("active");
          });
          button.classList.replace("button--ghosted-black", "button--black");
          button.classList.add("active");
          const unit = button.dataset.unit;
          this.convertNumbers(unit);
        }
      });
    });
  }

  convertNumbers(unit) {
    const numbers = this.querySelectorAll("[data-number]");
    numbers.forEach((number) => {
      const value = parseFloat(number.dataset.number);
      if (unit === "in") {
        number.textContent = parseFloat((value * 0.393701).toFixed(2));
      } else if (unit === "cm") {
        number.textContent = parseFloat((value * 0.393701 * 2.54).toFixed(2));
      }
    });
  }
}

customElements.define("unit-converter", UnitConverter);

class ImageZoom extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const image = this.querySelector("img.image-full");
    const ImageZoom = this.querySelector(".image-zoom-js");
    const closeImageZoom = this.querySelector(".close-image-zoom-js");
    const header = document.querySelector("site-header");

    image.addEventListener("click", () => {
      header.parentNode.classList.add("hidden");
      ImageZoom.classList.remove("hidden");

      document.body.classList.add("overflow-hidden");
    })

    closeImageZoom.addEventListener("click", () => {
      header.parentNode.classList.remove("hidden");
      ImageZoom.classList.add("hidden");

      document.body.classList.remove("overflow-hidden")
    });
  }
}

customElements.define("image-zoom", ImageZoom);


class ActiveButton extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const variant = urlParams.get('variant');
    this.variantLinks = this.querySelectorAll('.variant-link')

    if (!variant) {
      this.variantLinks[0].classList.add('active')

    }

    this.variantLinks.forEach((link, index) => {
      if (variant && link.dataset.variantId == variant) {
        link.classList.remove('active')
        link.classList.add('active')
      }
    })
  }
}

customElements.define("active-button", ActiveButton);



/*
Product Subscribe
*/
class ProductSubscribe extends HTMLElement {
  constructor() {
    super();
    this.setupListeners = this.setupListeners.bind(this);
    this.setSellingPlan = this.setSellingPlan.bind(this);
    this.setOneTimePurchase = this.setOneTimePurchase.bind(this);
  }

  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    this.subscriptionRadio = this.querySelector('#subscribeRadio');
    this.subscribeBox = this.querySelector('.subscribe-box-js')

    this.oneTimeRadio = this.querySelector('#oneTimeRadio');
    this.oneTimeBox = this.querySelector('.one-time-box-js');

    this.sellingPlanId = this.dataset.sellingPlanId;
    this.sellingPlanInput = this.querySelector('#selling-plan-js');

    if (this.subscriptionRadio) {
      this.subscriptionRadio.addEventListener('change', this.setSellingPlan);
    }

    if (this.oneTimeRadio) {
      this.oneTimeRadio.addEventListener('change', this.setOneTimePurchase);
    }

    this.setOneTimePurchase()
  }

  setSellingPlan() {
    if (this.subscriptionRadio.checked) {
      this.sellingPlanInput.value = this.sellingPlanId;
      this.subscribeBox.classList.remove('border-transparent')
      this.oneTimeBox.classList.add('border-transparent')
    }
  }

  setOneTimePurchase() {
    if (this.oneTimeRadio.checked) {
      if(this.sellingPlanInput){
        this.sellingPlanInput.value = "";
      }
      if(this.subscribeBox){
        this.subscribeBox.classList.add('border-transparent')
      }
      this.oneTimeBox.classList.remove('border-transparent')

    }
  }

  getCurrencyAndFormat(value) {
    function formatCurrency(value, currency) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
      }).format(value / 100);
    }
    let currency = Shopify.currency.active;

    return formatCurrency(value, currency);
  }
}

customElements.define("product-subscribe", ProductSubscribe);

/*
Numeric Stepper
*/
class NumericStepper extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const decrementButton = this.querySelector('#decrement');
    const incrementButton = this.querySelector('#increment');
    const quantityInput = this.querySelector('#quantity');
    const maxQuantity = parseInt(quantityInput.getAttribute('max'), 10);

    const decrementValue = () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    };

    const incrementValue = () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue < maxQuantity) {
        quantityInput.value = currentValue + 1;
      }
    };

    decrementButton.addEventListener('mousedown', () => {
      decrementValue();
      this.interval = setInterval(decrementValue, 200);
    });

    incrementButton.addEventListener('mousedown', () => {
      incrementValue();
      this.interval = setInterval(incrementValue, 200);
    });

    document.addEventListener('mouseup', () => {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    });

    quantityInput.addEventListener('input', () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue < 1) {
        quantityInput.value = 1;
      } else if (currentValue > maxQuantity) {
        quantityInput.value = maxQuantity;
      }
    });
  }
}

customElements.define("numeric-stepper", NumericStepper);


